var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconStatusOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.95 21L7.4 17.45L8.825 16.05L10.95 18.175L15.175 13.925L16.6 15.35L10.95 21ZM5 5V6H19V5H5ZM8.1 8L8.4 9H15.6L15.9 8H8.1ZM8.4 11C7.96667 11 7.575 10.871 7.225 10.613C6.875 10.355 6.63333 10.0173 6.5 9.6L6 8H5C4.45 8 3.97933 7.80433 3.588 7.413C3.19667 7.02167 3.00067 6.55067 3 6V3H21V6C21 6.55 20.8043 7.021 20.413 7.413C20.0217 7.805 19.5507 8.00067 19 8H18L17.35 9.7C17.2 10.0833 16.9583 10.396 16.625 10.638C16.2917 10.88 15.9167 11.0007 15.5 11H8.4Z",
    fill: "#2783EC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStatusOutline);
export default __webpack_public_path__ + "static/media/icon-status-outline.de813206661a71e2c36e0c6701d7ec01.svg";
export { ForwardRef as ReactComponent };